"use client";

import { FileText } from "lucide-react";

interface FormInstructionsCardProps {
    instructions?: string | null;
    className?: string;
    variant?: "default" | "compact";
}

export function FormInstructionsCard({ instructions, className = "", variant = "default" }: FormInstructionsCardProps) {
    if (!instructions) return null;

    if (variant === "compact") {
        return (
            <div
                className={`bg-slate-50 dark:bg-slate-900 p-4 border border-slate-200 dark:border-slate-800 rounded-md ${className}`}
            >
                <span className="font-semibold text-slate-900 dark:text-slate-100">Instructions:</span>
                <div className="mt-2 text-slate-700 dark:text-slate-300 leading-relaxed whitespace-pre-line">
                    {instructions}
                </div>
            </div>
        );
    }

    return (
        <div
            className={`bg-white dark:bg-slate-900 p-6 border border-slate-200 dark:border-slate-800 rounded-lg ${className}`}
        >
            <div className="flex items-center gap-2 mb-4">
                <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                <h2 className="font-bold text-slate-900 dark:text-slate-100 text-xl">Administration Instructions</h2>
            </div>
            <p className="text-slate-700 dark:text-slate-300 leading-relaxed whitespace-pre-line">{instructions}</p>
        </div>
    );
}
